import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getTotals } from 'services/glass-management/glassManagement';

export const fetchTotals = createAsyncThunk('glass/totals/fetch', async (filters) => {
    const res = await getTotals(filters.start, filters.end);
    return { data: res };
});

export const totalsSlice = createSlice({
    name: 'glassTotals',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchTotals.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTotals.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action?.payload?.data;
            })
            .addCase(fetchTotals.rejected, (state, action) => {
                state.loading = false;
                state.error = action?.error?.message ?? 'Failed to load totals';
                state.data = null;
            });
    }
});

export default totalsSlice.reducer;
